import { createFileRoute } from '@tanstack/react-router';

import { SalesScreen } from '@/screens/SalesScreen';

export const Route = createFileRoute('/_app/sales')({
  component: SalesScreen,
});
